import React from 'react';
import { Card } from '@/components/ui/card';
import { Users, Lock, Check, Minus } from 'lucide-react';

const Flag = ({ on }) => on
  ? <Check className="w-4 h-4 text-emerald-600 mx-auto" />
  : <Minus className="w-3.5 h-3.5 text-slate-300 mx-auto" />;

export default function EmployeesPage({ workplace, employees }) {
  if (!workplace) return <Card className="p-8 text-center text-slate-500">Najprv vyberte pracovisko.</Card>;

  return (
    <div className="max-w-3xl mx-auto space-y-3" data-testid="employees-page">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-heading font-semibold text-slate-900 flex items-center gap-2">
          <Users className="w-4 h-4" /> Zamestnanci <span className="text-slate-400 font-normal">({employees.length})</span>
        </h2>
      </div>

      <div className="flex items-start gap-2 text-[12px] text-slate-500 bg-slate-50 border border-slate-200 rounded-md px-3 py-2">
        <Lock className="w-3.5 h-3.5 mt-0.5 shrink-0 text-slate-400" />
        <span>Zamestnanci sa spravujú v <b>TiDo</b>. Tu sú len na čítanie – po zmene v TiDo klikni <b>Synchronizovať</b>.</span>
      </div>

      <Card className="overflow-hidden">
        <table className="w-full text-sm" data-testid="employees-table">
          <thead className="bg-slate-50 text-slate-500 text-[11px] uppercase">
            <tr>
              <th className="text-left px-3 py-2 font-medium">Meno</th>
              <th className="text-left px-3 py-2 font-medium">Zaradenie</th>
              <th className="text-center px-3 py-2 font-medium w-20">Víkendy</th>
              <th className="text-center px-3 py-2 font-medium w-20">Strieda</th>
              <th className="text-center px-3 py-2 font-medium w-20">V počte</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((e) => (
              <tr key={e.id} data-testid={`emp-row-${e.id}`} className="border-t border-slate-100">
                <td className="px-3 py-2 font-medium text-slate-800">{e.name}</td>
                <td className="px-3 py-2 text-slate-600" data-testid={`emp-type-${e.id}`}>
                  {e.employment_type_name || '—'}
                </td>
                <td className="px-3 py-2 text-center"><Flag on={e.works_weekends} /></td>
                <td className="px-3 py-2 text-center"><Flag on={e.rotates_shifts} /></td>
                <td className="px-3 py-2 text-center"><Flag on={e.counts_in_shift} /></td>
              </tr>
            ))}
            {employees.length === 0 && (
              <tr><td colSpan="5" className="text-center py-8 text-slate-400">Žiadni zamestnanci. Synchronizuj stredisko z TiDo.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
